var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm._l(_vm.allApplicants, function (applicant, applicantIndex) {
        return _c(
          "div",
          {
            key:
              _vm.applicantNameFromIndex(applicantIndex) + "-" + applicantIndex,
          },
          [
            _vm.isSectionVisibleToApplicant(applicantIndex, applicant.id)
              ? _c(
                  "page-summary-section-group-layout",
                  { attrs: { "show-divider": "" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "d-flex justify-content-between mb-4",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "section-title",
                              { attrs: { "title-type": "subtitle" } },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.applicantNameFromIndex(
                                          applicantIndex
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link text-primary p-0",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddIdentification(
                                      applicantIndex,
                                      applicant.id
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            + " +
                                    _vm._s(
                                      _vm.addIdentificationButtonText(applicant)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.applicantHasIdentification(applicant.identifications)
                      ? _c(
                          "b-row",
                          [
                            _c("b-col", { staticClass: "text-light-gray" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    applicantIndex
                                      ? _vm.$t(
                                          "application-standalone.pages.identifications.applicantHasNoIdentifications"
                                        )
                                      : _vm.$t(
                                          "application-standalone.pages.identifications.youHaveNoIdentifications"
                                        )
                                  ) +
                                  "\n        "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._l(
                          applicant["identifications"],
                          function (identification, identificationIndex) {
                            return _c(
                              "b-row",
                              {
                                key:
                                  "identification-" +
                                  applicant.id +
                                  "-" +
                                  identificationIndex,
                                staticClass: "mb-5",
                              },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "d-flex align-items-center",
                                    attrs: { cols: "5" },
                                  },
                                  [
                                    identification.type
                                      ? _c("span", { staticClass: "bold" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "application-form." +
                                                  identification.type
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("span", { staticClass: "bold" }, [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.ordinalIndex(
                                                  identificationIndex + 1
                                                )
                                              ) +
                                              "\n              " +
                                              _vm._s(
                                                _vm.$tc(
                                                  "application-form.identification",
                                                  1
                                                )
                                              )
                                          ),
                                        ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("span", { staticClass: "mr-1" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                identification["country"] ||
                                                  _vm.$t(
                                                    "application-form.country"
                                                  )
                                              ) +
                                              "\n              "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.isInvalid(
                                          applicantIndex,
                                          identificationIndex
                                        )
                                          ? _c(
                                              "application-section-error-icon",
                                              {
                                                attrs: {
                                                  id:
                                                    "error-tooltip-" +
                                                    identificationIndex,
                                                  "show-errors": _vm.showErrors,
                                                  "is-first-item":
                                                    identificationIndex ===
                                                    _vm.firstErrorId,
                                                },
                                              }
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(identification["number"]) +
                                          "\n            "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "auto" } }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-danger mr-1 my-lg-0 my-3",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDeletionModal({
                                            applicantIndex: applicantIndex,
                                            identificationIndex:
                                              identificationIndex,
                                          })
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("global.words.delete")
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary text-capitalize skip-disable-all-inputs",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleNavigation(
                                            applicantIndex,
                                            identificationIndex,
                                            applicant.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.allowEdit
                                        ? _c("icon", {
                                            staticClass: "text-primary mr-1",
                                            attrs: { name: "pencil" },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.editButtonText) +
                                          "\n            "
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            )
                          }
                        ),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("remove-component-modal", {
        ref: "removeComponentModal",
        attrs: { text: _vm.modalText },
        on: { accept: _vm.handleDelete },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }